(() => {
  const initGallery = (gallery) => {
    if (!gallery || gallery.dataset.smartLockGalleryReady === 'true') return;

    const slides = Array.from(gallery.querySelectorAll('[data-smart-lock-slide]'));
    const thumbs = Array.from(gallery.querySelectorAll('[data-smart-lock-thumb]'));
    const prev = gallery.querySelector('[data-smart-lock-prev]');
    const next = gallery.querySelector('[data-smart-lock-next]');
    const counter = gallery.querySelector('[data-smart-lock-counter]');

    if (!slides.length) return;

    gallery.dataset.smartLockGalleryReady = 'true';
    let activeIndex = 0;

    const showSlide = (index) => {
      const total = slides.length;
      activeIndex = ((index % total) + total) % total;

      slides.forEach((slide, slideIndex) => {
        const isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        if (isActive) {
          slide.removeAttribute('hidden');
        } else {
          slide.setAttribute('hidden', '');
        }
      });

      thumbs.forEach((thumb, thumbIndex) => {
        const isActive = thumbIndex === activeIndex;
        thumb.classList.toggle('is-active', isActive);
        thumb.setAttribute('aria-current', isActive ? 'true' : 'false');
      });

      if (counter) counter.textContent = (activeIndex + 1) + '/' + total;
    };

    if (prev) prev.addEventListener('click', () => showSlide(activeIndex - 1));
    if (next) next.addEventListener('click', () => showSlide(activeIndex + 1));
    thumbs.forEach((thumb, thumbIndex) => {
      thumb.addEventListener('click', () => showSlide(thumbIndex));
    });

    showSlide(0);
  };

  const initAll = () => {
    document.querySelectorAll('[data-smart-lock-gallery]').forEach(initGallery);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
